import React, { useEffect, useState } from "react";
// import logo from "./assets/Logo/logo.png";
// import { Link } from "react-router-dom";
import { BsLinkedin } from "react-icons/bs";
import { FaPhone } from "react-icons/fa6"
import { IoMdMail } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaMapMarkerAlt } from 'react-icons/fa';

export default function Hero() {
  return (
    <footer className="bg-gradient-to-br from-black to-slate-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">HAZOP</h3>
              <p className="text-gray-400">Where Cutting-Edge Technology Meets Uncompromising Safety</p>
              <div className="flex space-x-4 mt-4">
              <a
                href="https://in.linkedin.com/company/thesafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 hover:text-blue-800 transition-colors"
              >
                <BsLinkedin className="w-6 h-6" />
              </a>

              <a
                href="https://www.facebook.com/thesafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-700 transition-colors"
              >
                <FaFacebook className="w-6 h-6" />
              </a>

              <a
                href="https://twitter.com/thsafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ffffff] hover:text-[#daf1ff] transition-colors"
              >
                <FaXTwitter className="w-6 h-6" />
              </a>  

              <a
                href="https://www.youtube.com/channel/UCfBqBnuUfcMlORvhBaft7yA"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#f14d4d] hover:text-red-800 transition-colors"
              >
                <FaYoutube className="w-6 h-6" />
              </a>  

              <a
                href="https://api.whatsapp.com/send/?phone=917665231743&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#40db62] hover:text-green-800 transition-colors"
              >
                <FaWhatsapp className="w-6 h-6" />
              </a>  
              <a
                href="https://www.instagram.com/thesafetymaster_tsm/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-700 hover:text-pink-800 transition-colors"
              >
                <FaInstagram className="w-6 h-6" />
              </a>  



              <a
                href="info@thesafetymaster.com"
                className="text-[#D44638] hover:text-red-600 transition-colors"
              >
                {/* <Mail className="w-6 h-6" /> */}
              </a>
            </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><a href="#hero" className="text-gray-400 hover:text-white transition-colors">About</a></li>
                <li><a href="#process" className="text-gray-400 hover:text-white transition-colors">Process</a></li>
                <li><a href="#industries" className="text-gray-400 hover:text-white transition-colors">Industries</a></li>
                <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <a href="mailto:info@thesafetymaster.com" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <IoMdMail className="w-4 h-5 mr-2 text-white" />
            <p>info@thesafetymaster.com</p>
          </a>
              <a href="tel:+917665231743" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <FaPhone className="w-3 h-4 mr-2 text-white" />
            <p>+91 7665231743</p>
          </a>
           {/* Phone Number 2 */}
           <a href="tel:+919413882016" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <FaPhone className="w-3 h-4 mr-2 text-white" />
            <p>+91 9413882016</p>
          </a>

          {/* Address */}
         <a
          href="https://www.google.com/maps/search/?q=Unit+No+221,+Sunsquare+Plaza+Complex,+2nd+%26+4th+Floor,+450-451-452,+SPL1%2FJ,+RIICO+Chowk,+Bhiwadi,+Rajasthan+301019"
        target="_blank"
        rel="noopener noreferrer"
         className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500 mt-4"
       >
    <FaMapMarkerAlt className="w-8 h-10 mr-2 text-white" />
    <p>Unit No 221-445-450-451-452-453, 2nd & 4th Floor, Sunsquare Plaza Complex, RIICO Chowk, Bhiwadi, Rajasthan 301019</p>
  </a>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li><a href="https://www.thesafetymaster.com/privacy-policy/" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a></li>
                
              </ul>
              <p className="text-gray-400 mt-4">&copy; {new Date().getFullYear()} TSM Digitech. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
  );
}
